import { Component, Inject, Input, LOCALE_ID, OnInit, OnDestroy } from '@angular/core';
import { ApplicationFacade, CustomerCard, CustomerCardType, RelatedCardService } from '@ridango/components';
import { AppStartupService, CardGroup, BaseComponent, RelatedCard } from '@ridango/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-card-details-overview',
    templateUrl: './card-details-overview.component.html',
    styleUrls: ['./card-details-overview.component.css']
})
export class CardDetailsOverviewComponent extends BaseComponent implements OnInit, OnDestroy {
    readonly showDiscountGroups = this.env.RELATED_CARD?.SHOW_DISCOUNT_GROUPS ?? false;

    @Input() card: CustomerCard;
    discountGroups: CardGroup[];
    discountGroupsLoaded = false;

    assetsPath$ = this.applicationFacade.assetsPath$;
    cardType = CustomerCardType;

    constructor(
        @Inject('ENV') private env: Env,
        @Inject(LOCALE_ID) public locale: string,
        private applicationFacade: ApplicationFacade,
        private translate: TranslateService,
        private relatedCardService: RelatedCardService,
        public appStartupService: AppStartupService
    ) {
        super();
    }

    ngOnInit(): void {
        this.locale = this.translate.currentLang;
        this.translate.onLangChange
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(() => (this.locale = this.translate.currentLang));
        this.setCardDiscountGroups();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    setCardDiscountGroups(): void {
        this.discountGroupsLoaded = false;
        combineLatest([this.relatedCardService.getRelatedCards(), this.relatedCardService.fetchCardGroups()])
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(([relatedCards, cardGroups]) => {
                const relatedCard = relatedCards.find((card) => card.id === this.card.relatedCardId);

                if (!relatedCard) {
                    this.discountGroups = [];
                    return;
                }

                this.createGroups(relatedCard, cardGroups);
                this.discountGroupsLoaded = true;
            });
    }

    private createGroups(relatedCard: RelatedCard, cardGroups: CardGroup[]): void {
        const groupMap = new Map<string, CardGroup>(cardGroups.map((group) => [String(group.group_id), group]));

        this.discountGroups =
            relatedCard.groups
                ?.split(',')
                .map((id) => groupMap.get(id.trim()))
                .filter((group): group is CardGroup => Boolean(group)) ?? [];
    }
}
